const cursorPosition = event => event.touches ? event.touches[0].clientX : event.clientX;

export {
  cursorPosition
}